export default {"src":"/_next/static/media/lead-careersS.9cc5728d.svg","height":59,"width":299};